import Card from 'antd/lib/card';
import type { FC } from 'react';
import { useDepartments } from '@/common/useDepartments';
import { useAuth } from '@/core/providers/AuthFirebaseProvider';
import type { GetOrderHistoryQuery } from '@/generated/graphql/graphql';
import type { OrderChange, OrderState } from '@/interfaces/data/OrderRepositoryInterface';
import dayjs from '@/utils/dayjs-instance';
import { createOrderChangeFormatter, orderChangeFormatters } from '../components/formatters';
import { RowChangeView } from './components/RowChangeView';

export const OrderChangeView: FC<{
  change: GetOrderHistoryQuery['order_change'][0];
}> = ({ change }) => {
  const { userDataParams } = useAuth();
  const { selectedDepartment } = useDepartments();
  const createdAtWithTimezone = dayjs
    .utc(change?.createdAt)
    .utcOffset((selectedDepartment?.timeZone || 0) * 60);
  const createdAtDate = createdAtWithTimezone.format('DD, MMM');
  const createdAtTime = createdAtWithTimezone.format('HH:mm');
  let editorName = change?.editor?.name;

  if (editorName == null) {
    editorName = 'admin';
  } else if (change?.editor?.id === userDataParams?.sub) {
    editorName = 'You';
  }

  const adaptedChange: OrderChange = {
    editor: {
      id: change?.editor?.id || 'unknown',
      name: change?.editor?.name || 'admin',
    },
    new: change?.new as OrderState,
    old: change?.old as OrderState,
    createdAt: change?.createdAt,
  };

  return (
    <div style={{ padding: '4px 8px' }}>
      <Card
        style={{ padding: 0 }}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{editorName}</span>
            <div>
              <span style={{ color: '#1890ffaa', fontWeight: 400, fontSize: 14 }}>
                {createdAtDate}{' '}
              </span>
              <span style={{ color: '#1890ff' }}>{createdAtTime}</span>
            </div>
          </div>
        }
      >
        <div>
          <span>
            {(Object.keys(adaptedChange.old) as Array<keyof OrderState>)
              .filter((row) => orderChangeFormatters.includes(row as string))
              .map((row) =>
                RowChangeView(
                  row,
                  adaptedChange,
                  createOrderChangeFormatter(selectedDepartment?.timeZone || 0)
                )
              )}
          </span>
        </div>
      </Card>
    </div>
  );
};
